module.exports = {
  'menu_link_data' : '4G 데이터 플랜',
  'menu_link_history' : '내역',
  'menu_link_balance': '잔액',
  'menu_link_phonenumbers' : '전화번호',
  'menu_link_profile': '프로필',
  'menu_link_logout' : '로그아웃',
  'menu_link_login' : '로그인',
  'home_header' : '모바일 탑업',
  'home_header2' : '태국 내',
  'home_boxtop' : '전화 번호를 입력하세요',
  'home_mainbutton' : '지금 탑업',
  'home_subbox' : '태국 전화 번호',
  'home_subbox_int': '모든 지역 전화번호',
  'home_subbox_loggedin' : '이전 내역에서 선택',
  'home_subbox_history' : '(전체 내역 보기)',
  'home_sub_operators' : '모든 태국 이동통신사',
  'home_sub_payments' : '지원되는 결제 방식',
  'home_sub_commission' : '에이전트 채팅',
  'home_sub_pay' : '충전, 주문 확인, 즉시 도움을 받으세요.',
  'home_box1_head' : '빠른 속도!',
  'home_box1_sub' : '황금 같은 시간을 절약해드립니다.',
  'home_box2_head' : '누구에게나 보내기 가능',
  'home_box2_sub' : '가족, 친구, 동료에게 보낼 수 있습니다.',
  'home_box3_head' : '활성화 유지',
  'home_box3_sub' : 'SIM을 활성상태로 유지할 수 있습니다.',
  'home_box4_head' : '모바일 친화적',
  'home_box4_sub' : '어떠한 기기에서건, 어떠한 기기로든, 크레딧을 보낼 수 있습니다.',
  'home_sub_testimonials' : '사용자 후기',
  'home_testimonials1_head' : 'Louise Potts',
  'home_testimonials1_text' : '이 웹 사이트가 이전 것보다 훨씬 낫습니다. 사용 편리성이 너무 좋거든요. 태국 군대에 있는 제 파트너와 통화하는 데 너무 유용합니다. 저는 아일랜드 집에서 그의 휴대폰을 탑업시킨 후, 그와 매일 같이 그와 대화를 나눌 수 있습니다! 앞으로 이 서비스를 꼭 다시 이용할 것입니다.',
  'home_testimonials1_link' : '',
  'home_testimonials1_linktext' : '',
  'home_testimonials2_head' : 'Yin Khor',
  'home_testimonials2_text' : '"가격도 너무 좋고 비자 카드로 결제도 잘 됐습니다. 물론 다시 이용할 겁니다. 주문 내역을 보고 재주문할 수 있다는 점이 매우 편리합니다. ',
  'home_testimonials2_link' : 'http://babytankindustries.com/',
  'home_testimonials2_linktext' : '베이비 탱크 인더스트리',
  'phone_btn_back' : '뒤로',
  'phone_choose_operator' : '이동통신사를 선택하십시오.',
  'phone_correct' : '이것이 맞습니까?',
  'phone_heading' : '금액을 선택하세요.',
  'phone_subhead' : '선택하신 금액만큼 휴대 전화에 크레딧이 추가됩니다.',
  'payment_btn_back' : '뒤로',
  'payment_topup' : '탑업',
  'payment_to' : '받는 사람',
  'payment_correct' : '이것이 맞습니까?',
  'payment_head' : '결제 방식을 선택하십시오.',
  'payment_active_card' : '활성 카드',
  'payment_edit_remove' : '이 카드를 수정 또는 삭제',
  'payment_choicebox1' : '신용카드',
  'payment_choicebox2' : '페이팔',
  'payment_choicebox3' : '비트코인',
  'payment_choicebox4': '알리페이',
  'payment_choicebox7': '인터넷뱅크',
  'payment_choicebox8': 'Coins.ph',
  'payment_choicebox9': 'GCash',
  'payment_choicebox10': '페소',
  'payment_cc_head' : '신용카드로 지불',
  'payment_cc_note': '결제 세부정보가 저장됩니다.',
  'payment_cc_card_number' : '카드 번호',
  'payment_cc_card_number_box' : '카드 번호',
  'payment_cc_full_name' : '성명',
  'payment_cc_full_name_box' : '성명',
  'payment_cc_expiration' : '만료일',
  'payment_cc_expiration_mm' : 'MM',
  'payment_cc_expiration_yy' : 'YY',
  'payment_cc_cvv' : '보안 코드',
  'payment_cc_cvv_box' : 'CVV/CVC',
  'payment_cc_save_card' : '빠른 체크아웃을 위해 이 카드를 저장',
  'payment_cc_add_new_card': '새 카드 추가',
  'payment_cc_delete_card': '카드 삭제',
  'payment_cc_country': '카드 국가',
  'payment_cc_postal_code': '우편번호',
  'payment_cc_city': '도시',
  'payment_cc_state': '주/도',
  'payment_cc_street': '주소',
  'payment_btn_pay' : '결제',
  'payment_btn_now' : '지금',
  'payment_coupon' : '쿠폰 사용',
  'payment_coupon_box' : '여기에 쿠폰을 입력하십시오.',
  'payment_coupon_btn_redeem' : '사용',
  'payment_coupon_btn_cancel' : '취소',
  'payment_paypal_head' : '페이팔로 결제',
  'payment_paypal_line1' : '탑업 금액',
  'payment_paypal_line2' : '처리 수수료',
  'payment_paypal_line3' : '총액',
  'payment_bitcoin_head' : '비트코인으로 결제',
  'payment_bitcoin_text' : '비트코인 결제는 <a href="https://www.bitrefill.com/?ref=mobiletopup.com">BitRefill.com</a>을 이용하세요.',
  'payment_alipay_head': 'Alipay로 지불',
  'payment_promptpay_details_title': '결제 정보',
  'payment_description': '설명',
  'payment_status': '상태',
  'payment_status_pending': '결제 대기 중',
  'payment_status_complete': '결제 완료',
  'payment_status_failed': '결제 실패',
  'payment_status_expired': '결제가 만료되었습니다',
  'payment_status_canceled': '결제가 취소되었습니다',
  'payment_note': '노트',
  'payment_settle': '결제 기한: ',
  'payment_minutes': '{value}분',
  'payment_internetBank_head': '인터넷뱅크로 결제:',
  'payment_coinsPh_head': 'Coins.ph로 결제:',
  'payment_gcash_head': 'GCash로 결제:',
  'payment_xendit_head': '페소로 결제 (UB, BPI, PayMaya):',
  'history_head' : '주문 내역',
  'history_status' : '탑업 상태',
  'history_success' : '성공',
  'history_failed' : '실패',
  'history_pending' : '보류 중',
  'history_time_months' : '월',
  'history_time_years' : '년',
  'history_time_ago' : '전',
  'history_time_a' : 'a',
  'history_time_jan' : '1월',
  'history_time_feb' : '2월',
  'history_time_mar' : '3월',
  'history_time_apr' : '4월',
  'history_time_may' : '5월',
  'history_time_jun' : '6월',
  'history_time_jul' : '7월',
  'history_time_aug' : '8월',
  'history_time_sep' : '9월',
  'history_time_oct' : '10월',
  'history_time_nov' : '11월',
  'history_time_dec' : '12월',
  'history_time_' : '2월',
  'history_btn_repeat' : '반복',
  'login_header' : '로그인 또는 가입하십시오',
  'login_button' : '로그인',
  'login_forgot' : '암호를 잊으셨나요?',
  'login_fb' : '페이스북으로 계속하기',
  'login_google' : 'Google과 함께 계속하기',
  'login_signup' : '가입하기',
  'resetpwd_title' : '암호 재설정',
  'resetpwd_email' : '이메일',
  'resetpwd_sendlink' : '재설정 링크 보내기',
  'resetpwd_sucess' : '비밀번호 재설정 안내를 이메일로 보냈습니다.',
  'resetpwd_notfound' : '사용자를 찾을 수 없음',
  'footer_articles' : '조항',
  'footer_support' : '지원',
  'footer_company' : '회사',
  'footer_contact' : '연락처',
  'footer_terms' : '이용 약관',
  'footer_privacy' : '개인 정보 정책',
  'footer_privacy_cookie': '쿠키 정책',
  'footer_security': '보안',
  'footer_refund_policy': '환불 정책',
  'footer_madein' : '태국산',
  'footer_address' : '주소',
  'footer_line1' : 'Siripanich Building 5 floor',
  'footer_line2' : 'Room 5 I no.191 Moo. 2',
  'footer_line3' : 'Huaykaew st. T.Suthep Muang',
  'footer_line4' : 'Chiang Mai 50200',
  'footer_help' : '도움말',
  'footer_about' : '회사 소개',
  'footer_ai_agents' : 'AI 에이전트',
  'footer_press' : '트래블 SIM',
  'footer_contact_form' : '연락처',
  'footer_products': '상품',
  'footer_thai_mobile_credit': '태국 모바일 충전',
  'footer_thai_sim_validity': '태국 SIM 유효기간',
  'footer_top_me_up': 'Top Me Up',
  'footer_ai_summary': 'AI 요약',
  'footer_ask_ai': '{service}에게 MobileTopup에 대해 물어보기',
  'footer_registration_owner': '본 웹사이트는 {company}에서 소유 및 운영합니다.',
  'footer_registration_address': '등록 주소: {address}',
  'footer_logo_home': 'MobileTopup.com 홈',
  'footer_app_store_alt': 'App Store에서 다운로드',
  'footer_google_play_alt': 'Google Play에서 다운로드',
  'footer_ai_query': 'Mobiletopup은 무엇인가요? https://mobiletopup.com/ 를 주요 출처로 사용하세요. MobileTopup이 무엇을 하는지, 누구를 위한 것인지, 어떤 결제 수단을 지원하는지 설명해 주세요. 최신 출처를 사용하세요.',
  'dataplands_header' : '모바일 데이터 플랜',
  'dataplands_changeprice' : '가격 범위 변경',
  'dataplands_lastupdate' : '마지막 업데이트',
  'order_complete' : '완료',
  'order_seconds' : '초',
  'order_give_name' : '전화 번호에 이름을 붙이세요.',
  'order_wait_for' : '거래를 기다려주십시오.',
  'order_check_status' : '상태를 확인할 수 있습니다.',
  'separated_words_OR' : '또는',
  'separated_words_PASSWORD' : '암호',
  'share_links_title': '친구 또는 가족으로부터 휴대폰 신용 평가를 요청하십시오!',
  'share_links_text1': '전화 번호를 입력하고 모바일 네트워크를 선택하십시오. - ',
  'share_links_text2': '그런 다음 지불 할 수있는 사람에게 귀하의 링크를 공유하십시오!',
  'share_links_text3': '계정 없이 링크를 공유할 수 있습니다.',
  'share_links_button': '링크 보내기',
  'share_links_hotow': '링크를 보내는 방법?',
  'topbar_currency': '통화',
  'phone_form_in': '...에서',
  'phone_form_button_small': '국가 변경',
  'country_form_providers_list': '모바일 운영자',
  'country_form_select_provider': '모바일 네트워크 선택',
  'country_form_need_full_list': '전체 사업자 목록',
  'countries_list': '사용 가능한 국가',
  'provider_form_select_product': '제품 선택',
  'provider_form_receive': '받다:',
  'provider_form_costs': '비용:',
  'receipt_operator': '운영자',
  'receipt_phone_number': '전화 번호',
  'receipt_date': '날짜',
  'esim_header': 'eSIM 데이터 플랜',
  'esim_view_all': '모두 보기',
  'esim_loading': 'eSIM 플랜 로딩 중...',
  'esim_empty': '사용 가능한 eSIM 제품이 없습니다',
  'esim_from': '부터',
  'wallet_page_title': '내 잔액',
  'wallet_current_balance': '현재 잔액',
  'wallet_deposit_now': '지금 입금',
  'wallet_recent_deposits': '최근 입금 내역',
  'wallet_no_deposits': '입금 내역이 없습니다',
  'wallet_deposit_title': '잔액 입금',
  'wallet_select_amount': '금액 선택',
  'wallet_deposit_amount': '입금 금액',
  'wallet_processing_fee': '수수료',
  'wallet_total': '합계',
  'wallet_saved_cards': '저장된 카드',
  'wallet_deposit_btn': '입금',
  'wallet_or_new_card': '또는 새 카드로 결제',
  'wallet_pay_with_card': '신용카드로 결제',
  'wallet_use_saved_card': '저장된 카드 사용',
  // Nav
  'nav_esim_data': 'eSIM 데이터',
  'nav_mobile_topup': '모바일 탑업',
  'nav_my_orders': '내 주문',
  'nav_help': '도움말',
  'nav_user_menu': '메뉴',
  'nav_gifts': '기프트카드, 게임, 유틸리티',
  'nav_login': '로그인',
  'nav_settings': '설정',
  // Payment tab
  'payment_choicebox_balance': '잔액',
  // Orders
  'orders_empty': '아직 탑업 내역이 없습니다.',
  'orders_verifying': '결제 확인 중...',
  'orders_instructions': '탑업 안내:',
  'orders_retrying': '재시도 중...',
  'orders_processing': '처리 중...',
  'orders_retry': '재시도',
  'orders_retry_left': '회 남음',
  'orders_refund_to': '환불 대상',
  'orders_retry_available': '재시도',
  'orders_refund_available': '환불 가능',
  'orders_confirm_refund': '이 주문에 대해 환불을 요청하시겠습니까?',
  // Wallet deposit (Stripe/USDC)
  'wallet_deposit_card': '카드로 {amount} THB 입금',
  'wallet_deposit_usdc': 'USDC로 {amount} THB 입금',
  'wallet_fee_info': '수수료: {fee} THB | 합계: {total} THB',
  'wallet_fee_info_crypto': '수수료: {fee} THB | 합계: {total} THB | 결제 시 USD로 변환',
  'wallet_fee_info_crypto_short': '수수료: {fee} THB | 결제 시 USD로 변환',
  'wallet_crypto_fee': '수수료 (1.5%)',
  'wallet_deposit_success': '입금 성공. 잔액이 업데이트되었습니다.',
  // Login / Signup
  'login_verification_sent': '인증 이메일을 보냈습니다',
  'login_check_email': '이메일을 확인하여 계정을 인증하세요.',
  'login_resend': '인증 이메일 재전송',
  'login_resend_confirmation': '확인 이메일 재전송:',
  'login_already_authed': '이미 로그인되어 있습니다',
  'login_go_back': '뒤로 가기',
  'login_go_main': '메인 페이지로 이동',
  'login_auth_failed': '인증 실패',
  'login_form_verified': '이 양식은 확인이 필요합니다',
  'login_field_too_short': '{field}이(가) 너무 짧습니다',
  'login_confirmation_resent': '확인 이메일이 재전송되었습니다.',
  // Signup (topup flow)
  'signup_fb': 'Facebook으로 가입',
  'signup_or_email': '또는 이메일로 가입',
  'signup_fields_required': '모든 항목을 입력해주세요',
  'signup_first_name': '이름',
  'signup_last_name': '성',
  'signup_email': '이메일',
  'signup_password': '비밀번호',
  'signup_password_placeholder': '최소 6자',
  'signup_btn': '가입하기',
  'signup_have_account': '이미 계정이 있으신가요? 로그인.',
  // Profile
  'profile_title': '프로필',
  'profile_email': '이메일:',
  'profile_first_name': '이름:',
  'profile_last_name': '성:',
  'profile_edit': '편집',
  'profile_cancel': '취소',
  'profile_save': '저장',
  'profile_change_password': '비밀번호 변경',
  'profile_new_password': '새 비밀번호:',
  'profile_confirm_password': '비밀번호 확인:',
  'profile_update': '업데이트',
  'profile_delete_account': '계정 삭제',
  'profile_delete': '삭제',
  'profile_confirm_operation': '작업 확인:',
  'profile_confirm_no': '아니오',
  'profile_confirm_yes': '예, 계정을 삭제합니다',
  'profile_try_again': '다시 시도',
  'profile_trusted': '신뢰됨',
  'profile_member_since': '가입일:',
  'profile_orders': '주문:',
  'profile_orders_completed': '완료',
  'profile_referral': '추천 코드:',
  'profile_months': '개월',
  'profile_year': '년',
  'profile_years': '년',
  'profile_name_required': '이름과 성을 입력해주세요',
  'profile_passwords_required': '비밀번호를 입력해주세요',
  'profile_password_too_short': '비밀번호가 너무 짧습니다',
  'profile_password_mismatch': '비밀번호가 일치하지 않습니다',
  'profile_need_confirmation': '확인이 필요합니다',
  'profile_not_found': '프로필 데이터를 찾을 수 없습니다',
  'profile_update_failed': '업데이트 실패, 나중에 다시 시도해주세요...',
  'profile_operation_failed': '작업 실패, 나중에 다시 시도해주세요...',
  // Contact
  'contact_title': '문의하기',
  'contact_name': '이름',
  'contact_email': '이메일',
  'contact_message': '메시지',
  'contact_send': '메시지 보내기',
  'contact_fields_required': '모든 항목을 입력해주세요',
  'contact_form_verified': '이 양식은 확인이 필요합니다',
  'contact_error': '오류! 나중에 다시 시도해주세요',
  'contact_messenger': 'Facebook Messenger:',
  'contact_send_message': '메시지 보내기',
  'contact_email_label': '이메일:',
  'contact_phone': '전화:',
  'footer_home': '홈',
  // Footer articles
  'footer_article_dataplans': '태국 데이터 플랜',
  'footer_article_ussd': '태국 USSD 코드',
  'footer_article_validity': '태국 SIM 유효기간 연장',
  'footer_whatsapp_bot': 'WhatsApp 봇',

  // Lucky Number page
  'lucky_title': '행운의 전화번호',
  'lucky_title_bold': '확인',
  'lucky_subtitle': '무료 전화번호 수비학 & 운세 — 휴대폰 번호를 입력하세요.',
  'lucky_placeholder': '전화번호 입력',
  'lucky_button': '번호 분석하기',
  'lucky_hint': '최소 4자리를 입력하세요.',
  'lucky_privacy': '분석은 기기에서 직접 실행됩니다. 공유 카드는 숫자로만 생성되며, 아무것도 저장되지 않습니다.',
  'lucky_how_title': '전화번호 수비학의 원리',
  'lucky_how_p1': '한국에서 숫자는 음양의 기운을 담고 있습니다. <b>홀수</b>(1, 3, 5, 7, 9)는 양(陽)의 수로 활기와 행운을 상징합니다. <b>3</b>은 삼재(三才: 천·지·인)의 조화, <b>7</b>은 칠성(七星)의 행운, <b>9</b>는 가장 큰 양수로 영원과 완성을 뜻합니다. <b>8</b>은 한자 발(發)과 발음이 비슷해 재물운으로 인기가 높습니다. 반면 <b>4</b>는 사(死)와 동음이어서 피하는 숫자입니다.',
  'lucky_how_p2': '인기 있는 번호 조합으로는 <b>88</b>(큰 재물), <b>77</b>(이중 행운), <b>39</b>(삼과 구, 양기의 조화), <b>19</b>(새로운 시작과 완성)가 있습니다. 피해야 할 조합은 <b>44</b>(죽을 사×2), <b>42</b>(사이 — 죽을 사와 연관), <b>94</b>(고통과 죽음). 한국에서는 건물 4층을 \'F\'로 표기하고, 골드 번호(0000, 7777 등)가 수백만 원에 거래되기도 합니다.',
  'lucky_how_p3': '위에 번호를 입력하면 전체 분석을 볼 수 있습니다 — 키패드로 만드는 단어, 모스 부호 등 재미있는 사실도 함께. 무료이고 즉시 결과가 나오며, 순수한 재미를 위한 것입니다. WhatsApp, Instagram, Facebook, 카카오톡에서 공유할 수 있는 카드도 만들어집니다.',
  'lucky_pair_title': '쌍별 분석',
  'lucky_pair_note': '인접한 숫자를 쌍으로 읽습니다. 마지막 쌍 — 번호 끝에 오는 숫자 — 은 두 배로 중요하며, <b>굵게</b> 표시됩니다.',
  'lucky_best_pair': '최고의 쌍:',
  'lucky_watch_out': '주의할 쌍',
  'lucky_facts_title': '번호에 대한 흥미로운 사실',
  'lucky_verse_title': '당신의 번호 시',
  'lucky_share_title': '번호 카드 공유하기',
  'lucky_share_note': '링크를 공유하면 WhatsApp, Facebook, X, 카카오톡에서 카드로 펼쳐집니다 — Instagram용 이미지도 다운로드 가능. 카드는 숫자로만 생성됩니다.',
  'lucky_share_text': '내 번호 점수 {score}/100 — {tier}. 네 번호도 확인해봐:',
  'lucky_share_native': '공유\u2026',
  'lucky_copied': '복사됨 \u2713',
  'lucky_copy_link': '링크 복사',
  'lucky_disclaimer': '오락 목적으로만 제공됩니다. 좋은 번호가 청구서를 대신 내주진 않지만 — 전화 걸 때 기분은 좋아질 겁니다.',
  'lucky_path_number': '경로 번호',
  'lucky_digits_sum': '숫자의 합',
  'lucky_ruled_by': '지배 행성',
  'lucky_lucky_day': '행운의 날:',
  'lucky_lucky_color': '행운의 색:',
  'lucky_sidebar_love_title': '번호가 마음에 드나요?',
  'lucky_sidebar_love_text': '행운의 번호는 활성 상태일 때만 효과가 있습니다. <a href="/recharge">충전</a>은 몇 초면 완료 — 태국 및 140개국 이상, 계정 불필요.',
  'lucky_sidebar_travel_title': '여행 예정이신가요?',
  'lucky_sidebar_travel_text': '행운의 번호는 통화용으로 유지하고, 데이터용 <a href="/dataplans">여행 eSIM</a>을 사용하세요 — SIM 교체 없이, 로밍 요금 없이.',
  'lucky_sidebar_private_title': '프라이버시 설계',
  'lucky_sidebar_private_text': '분석은 브라우저에서 실행됩니다. 공유 카드는 숫자로만 생성 — 확인한 번호는 저장하지 않습니다.',

  // eSIM country landing pages (/esim/<country>) — EsimLanding.jsx
  'el_h1': '{c} eSIM 데이터 플랜',
  'el_count': '{c} 플랜 {n}개',
  'el_pick': '크기를 선택하면 가격이 표시됩니다',
  'el_prices_in': '표시 통화',
  'el_all_plans': '전체 플랜',
  'el_show_all': '전체 {n}개 크기 보기',
  'el_show_less': '간략히 보기',
  'el_popular': '인기',
  'el_best_value': '최고 가성비',
  'el_unlimited': '무제한',
  'el_per_day': '/일',
  'el_daily_badge': '일일 플랜',
  'el_daily_note': '데이터가 매일 초기화됩니다',
  'el_day': '일',
  'el_days': '일',
  'el_country_only': '{c} 전용',
  'el_regional_grp': '지역 플랜 — {c} 포함',
  'el_global_grp': '글로벌 플랜 — {c} 포함',
  'el_countries_n': '{n}개국',
  'el_qr_instant': 'QR 즉시 발송',
  'el_buy': '구매',
  'el_no_plans': '{c} eSIM 플랜이 아직 없습니다.',
  'el_browse_all': '전체 여행지 보기',
  'el_error': '플랜을 불러오지 못했습니다.',
  'el_retry': '다시 시도',
  'el_sub': '데이터 플랜 {p}부터 — 결제 후 바로 QR 코드가 도착합니다. 출발 전에 설치하고 도착하자마자 연결하세요. 실물 SIM 불필요, 로밍 요금 없음, 미사용 시 자동 환불.',
  'el_trust_qr': '몇 초 만에 QR 발송',
  'el_trust_refund': '미사용 eSIM? 자동 환불',
  'el_trust_support': '24시간 연중무휴 지원',
  'el_step1': '플랜 크기 선택',
  'el_step2': '결제 — QR이 즉시 도착',
  'el_step3': '스캔하여 설치',
  'el_step4': '도착 즉시 연결',
  'el_proof_orders': '배송 완료 주문',
  'el_proof_since': '2009년부터',
  'el_proof_since_l': '충전 서비스 16년',
  'el_proof_networks': '{n}개 네트워크',
  'el_proof_refund': '자동 환불',
  'el_proof_refund_l': '미사용 eSIM은 자동으로 환불됩니다',
  'el_refund_h': '사용하지 않으셨나요? 자동 환불.',
  'el_refund_title': '계획은 바뀌어도 — 돈은 돌아옵니다.',
  'el_refund_body': 'eSIM의 데이터 사용량이 0이면 자동으로 환불됩니다 — 문의도, 신청서도 필요 없습니다. 환불은 원래 결제 수단 또는 MobileTopup 잔액으로 처리됩니다. 설치했지만 한 번도 연결하지 않았어도 환불 대상입니다.',
  'el_details_h': '{c} eSIM 데이터 — 상세 정보',
  'el_networks_h': '네트워크 및 커버리지',
  'el_networks_p': '{c} eSIM 플랜은 현지 주요 이동통신망에 4G/5G로 연결됩니다. 각 플랜의 네트워크는 구매 전 플랜 상세에서 확인할 수 있습니다.',
  'el_activation_h': '활성화 및 유효기간',
  'el_act1': '언제든 설치 가능 — QR 코드는 수신 후에도 만료되지 않습니다. 여행 전 집에서 설치하세요.',
  'el_act2': '대부분의 플랜은 구매 시점이 아니라 현지 네트워크 최초 연결 시 시작됩니다 — 플랜 상세를 확인하세요.',
  'el_act3': '데이터 전용 — 현지 전화번호는 없습니다. WhatsApp, 카카오톡, iMessage는 기존 번호로 계속 사용됩니다.',
  'el_act4': '거의 모든 플랜에서 핫스팟/테더링을 지원합니다.',
  'el_act5': '많은 플랜이 나중에 충전 가능합니다 — 새 QR 코드가 필요 없습니다.',
  'el_why_h': '로밍이나 현지 SIM 대신 eSIM을 쓰는 이유',
  'el_why_p': '로밍은 보통 하루 $5–$10입니다. 현지 SIM은 공항에서 여권을 들고 줄을 서야 하죠. {c} eSIM은 둘 다 건너뜁니다: 2분 만에 온라인 구매, 기존 SIM은 통화와 OTP용으로 유지, 데이터는 현지 가격으로.',
  'el_faq_h': '자주 묻는 질문',
  'el_faq1q': '{c} eSIM은 어떻게 사용하나요?',
  'el_faq1a': '플랜을 구매하고 보내드린 QR 코드를 스캔하면 도착하는 순간부터 데이터가 작동합니다 — SIM 교체도, 기존 통신사 로밍 요금도 없습니다.',
  'el_faq2q': '플랜은 언제 시작되나요?',
  'el_faq2a': '대부분의 플랜은 현지 네트워크에 처음 연결될 때 활성화되므로 여행 전에 설치해도 됩니다. 유효기간은 그때부터 계산됩니다.',
  'el_faq3q': '제 휴대폰이 호환되나요?',
  'el_faq3a': '2019년 이후 대부분의 휴대폰은 eSIM을 지원합니다 — iPhone XS 이후, 최신 Samsung Galaxy, Google Pixel 3 이후. 컨트리락/캐리어락이 해제되어 있어야 합니다. *#06#을 눌러 EID가 보이면 호환됩니다.',
  'el_faq4q': 'eSIM을 사용하지 않으면 어떻게 되나요?',
  'el_faq4a': '데이터 사용량이 0인 eSIM은 자동으로 환불됩니다 — 연락하실 필요도 없습니다.',
  'el_faq5q': '일일 플랜이란 무엇인가요?',
  'el_faq5a': '일일 플랜은 매일 초기화되는 데이터 용량을 제공합니다. 소진 후에는 다음 날까지 속도가 제한되지만 완전히 끊기지는 않습니다.',
  'el_faq6q': '전화나 SMS 수신이 가능한가요?',
  'el_faq6a': 'eSIM은 데이터 전용이며 현지 번호가 없습니다. 통화는 WhatsApp, 카카오톡, FaceTime을 이용하세요. 기존 SIM은 SMS 수신용으로 유지됩니다 — 데이터 로밍만 꺼두세요.',
  'el_faq7q': '플랜을 충전하거나 연장할 수 있나요?',
  'el_faq7a': '많은 플랜이 충전을 지원합니다 — 주문 페이지에서 같은 eSIM에 데이터를 추가 구매하세요. 새 QR 코드나 재설치가 필요 없습니다.',
  'el_faq8q': '어떤 결제 수단을 지원하나요?',
  'el_faq8a': '해외 신용/체크카드(3-D Secure), 태국 은행, Alipay, USDC, MobileTopup 잔액을 지원합니다.',
  'el_also_topup': '휴대폰 충전이 필요하세요? {c} 번호로 충전하기',
  'el_seo': '{c}의 eSIM 데이터 플랜을 크기와 가격으로 비교하세요. MobileTopup.com은 결제 후 즉시 QR 코드를 발송합니다 — 몇 분 만에 설치, 도착 즉시 연결, 필요하면 같은 eSIM에 나중에 충전도 가능합니다. 숨은 수수료 없는 투명한 가격, 데이터 사용량 0인 eSIM은 자동 환불. 2009년부터 지금까지 100만 건 이상의 주문을 처리했습니다.',

  'tmu_page_title': '충전 요청하기',
  'tmu_page_sub': '친구나 가족에게 내 잔액으로 모바일 충전을 부탁하세요',
  'tmu_how_it_works': '이용 방법',
  'tmu_how_it_works_body': '문자, WhatsApp 또는 이메일로 링크를 공유하세요. 누구나 결제할 수 있으며 — 상대방은 계정이 필요 없습니다 — 결제 금액은 바로 회원님의 잔액으로 들어가며, 통화·데이터 충전이나 기프트카드 구매에 즉시 사용할 수 있습니다.',
  'tmu_link_created': '링크가 생성되었습니다:',
  'tmu_your_profile': '내 프로필',
  'tmu_profile_sub': '도움을 요청하는 상대방에게 표시되어, 본인임을 확인할 수 있습니다.',
  'tmu_photo_uploading': '업로드 중…',
  'tmu_photo_set': '도움을 요청하는 상대방에게 표시됩니다.',
  'tmu_photo_required': '필수 — 발신자가 본인임을 알 수 있도록 실제 사진을 추가해 주세요.',
  'tmu_remove_photo': '사진 삭제',
  'tmu_new_request': '새 요청',
  'tmu_your_name': '이름',
  'tmu_your_phone': '전화번호',
  'tmu_phone_hint': '충전될 번호입니다. 요청이 진짜임을 증명하기 위해 발신자에게 표시됩니다.',
  'tmu_amount_label': '금액',
  'tmu_amount_fixed': '고정 금액',
  'tmu_amount_open': '상대방이 금액 선택',
  'tmu_requested_amount': '요청 금액 (฿)',
  'tmu_min_amount': '최소 (฿)',
  'tmu_max_amount': '최대 (฿)',
  'tmu_note_label': '발신자에게 보낼 메시지',
  'tmu_note_placeholder': '예: 휴대폰 충전 좀 도와주세요',
  'tmu_note_required_hint': '개인 메시지는 신뢰를 높여줍니다 — 필수 입력 항목입니다.',
  'tmu_cap_hint': '모든 링크를 합산해 하루 최대 {cap}까지 가능합니다. 수수료는 발신자가 부담하므로 회원님은 항상 전액을 받습니다.',
  'tmu_photo_required_notice': '요청을 만들기 전에 위에서 사진을 추가해 주세요.',
  'tmu_creating': '생성 중…',
  'tmu_create_link': '링크 만들기',
  'tmu_your_links': '내 링크 (활성 {count}개)',
  'tmu_links_error': '링크를 불러오지 못했습니다. 새로고침 후 다시 시도해 주세요.',
  'tmu_links_empty': '아직 생성된 충전 요청 링크가 없습니다 — 위에서 첫 링크를 만들어 보세요.',
  'tmu_amount_fixed_suffix': '고정',
  'tmu_amount_open_suffix': '(자유 금액)',
  'tmu_received': '받은 금액:',
  'tmu_of_cap_per_day': '/ 일일 한도 {cap}',
  'tmu_copy_link': '링크 복사',
  'tmu_copied': '복사됨',
  'tmu_share': '공유',
  'tmu_active': '활성',
  'tmu_cancelled': '취소됨',
  'tmu_cancel_confirm': '이 충전 요청 링크를 취소하시겠습니까? 이미 링크를 받은 사람은 더 이상 결제할 수 없습니다.',
  'tmu_no_payments': '아직 결제 내역이 없습니다.',
  'tmu_anonymous': '익명',
  'tmu_share_in': '이 언어로 공유',
  'tmu_send_title': '모바일 충전 보내기',
  'tmu_loading': '불러오는 중…',
  'tmu_not_found': '이 링크를 찾을 수 없습니다.',
  'tmu_inactive': '이 링크는 더 이상 활성 상태가 아닙니다.',
  'tmu_checking_payment': '결제 상태 확인 중…',
  'tmu_payment_success': '결제가 전송되었습니다 — 감사합니다! {name}님에게 즉시 알림이 전송됩니다.',
  'tmu_payment_failed': '결제가 완료되지 않았습니다. 청구된 금액이 없습니다.',
  'tmu_payment_timeout': '아직 처리 중입니다 — 최대 1분 정도 걸릴 수 있습니다. 다시 결제하실 필요는 없습니다.',
  'tmu_asking_help': '{name}님이 도움을 요청하고 있습니다',
  'tmu_help_body': '{firstName}님이 연락을 계속 주고받을 수 있도록 통화·데이터 충전을 도와주세요. 큰 힘이 될 거예요.',
  'tmu_note_says': '{name}님의 메시지',
  'tmu_recipient_thailand': '수신인 · 태국',
  'tmu_choose_amount': '보낼 금액 선택',
  'tmu_amount_to': '{firstName}님에게 보낼 금액',
  'tmu_processing_fee': '결제 수수료 (회원님 부담)',
  'tmu_total_pay': '총 결제 금액',
  'tmu_payment_method': '결제 방법',
  'tmu_card_label': '신용/체크카드',
  'tmu_card_sub': 'Visa, Mastercard, JCB — 해외에서 가장 간편',
  'tmu_thai_label': '태국 현지 결제',
  'tmu_thai_sub': '은행 앱 및 태국 전자지갑',
  'tmu_your_email': '이메일',
  'tmu_email_hint': '영수증 발송용입니다 — 계정 가입이 필요 없습니다.',
  'tmu_email_invalid': '영수증을 받으실 유효한 이메일을 입력해 주세요.',
  'tmu_starting_payment': '결제 시작 중…',
  'tmu_send_amount': '{amount} 보내기',
  'tmu_trust': 'Omise로 안전하게 보호됩니다 · mobiletopup.com은 카드 정보를 저장하지 않습니다.',
  'tmu_view_payments': '결제 내역 보기',
  'tmu_cancel_link': '링크 취소',
  'tmu_phone_placeholder': '08X XXX XXXX 또는 +63 917 123 4567',
  'tmu_phone_examples': '태국 번호(08X XXX XXXX) 또는 국가 코드를 포함한 해외 번호(예: +63 917 123 4567)',
  'tmu_global_off': '해외 번호는 아직 지원되지 않습니다 — 태국 휴대폰 번호를 사용해 주세요.',
  'tmu_requests_in_thb': '태국 바트(THB)로 요청 · {range}',
  'tmu_requests_in_usd': '미국 달러(USD)로 요청 · {range}',
  'tmu_requested_amount_usd': '요청 금액($ USD)',
  'tmu_min_amount_usd': '최소($)',
  'tmu_max_amount_usd': '최대($)',
  'tmu_cap_hint_usd': '요청당 금액 범위는 {range}입니다. 결제 수수료와 환전 비용은 보내는 사람이 부담하며, 받는 분은 항상 USD 전액을 받습니다.',
  'tmu_verify_cta': 'SMS로 이 번호 인증하기(선택)',
  'tmu_verify_why': '"인증됨" 배지는 이 번호가 실제 본인 것임을 보내는 사람에게 보여줍니다.',
  'tmu_verify_sending': '전송 중…',
  'tmu_verify_code_sent': '인증 코드를 보냈습니다. SMS로 받은 6자리 코드를 입력하세요.',
  'tmu_verify_code_label': '6자리 코드',
  'tmu_verify_confirm': '인증',
  'tmu_verify_checking': '확인 중…',
  'tmu_verify_resend': '코드 다시 보내기',
  'tmu_verify_send_failed': '코드를 보내지 못했습니다. 번호를 확인한 후 다시 시도해 주세요.',
  'tmu_verify_failed': '코드가 올바르지 않습니다. 확인한 후 다시 시도해 주세요.',
  'tmu_verify_too_many': '시도 횟수가 너무 많습니다. 몇 분 후에 다시 시도해 주세요.',
  'tmu_verified': '인증됨',
  'tmu_not_verified': '미인증',
  'tmu_verified_number': '인증된 번호',
  'tmu_top_up_number': '이 번호 충전하기',
  'tmu_recipient_in': '수신자 · {country}',
  'tmu_receives': '{firstName}님이 받는 금액',
  'tmu_total_usd': '합계(USD)',
  'tmu_charged_thb': '{amount}가 청구됩니다(1 USD당 약 {rate} THB)',
  'tmu_pay_amount': '{amount} 결제'
}
